module.exports = __webpack_public_path__ + "static/media/database.8f4193d8.svg";